import connector from "./connector";
import { config } from "./config";

export async function signIn({ username, password }) {
  try {
    const response = await connector.post("/api/signin", {
      username,
      password,
      apiKey: config.apiKey,
    });

    return {
      data: response.data || {},
      connector_state: {
        status: response.status,
        statusText: response.statusText,
      },
    };
  } catch (error) {
    return connector.catchReturn(error, {});
  }
}
